import { Order } from '../../gql/graphql';
import { updateCustomerInMultiContext } from '../../helpers/launchDarkly/ldContext.helper';
import { createUnauthorizedErrorMessage, createForbiddenErrorMessage } from '../../helpers/security/security';
import orderService from '../../services/order.service';
import { NetworkError } from '../../state-machine/actions/genericActions';
import { OrderIdMachineContext } from '../../state-machine/types/shared/context/orderIdMachineContext';

const queryOrderWithCartValidation = async (context: OrderIdMachineContext): Promise<Order> => {
  try {
    const { data, errors } = await orderService.getOrderByIdWithCartValidation(context.orderId);
    const orderData = data.order;

    if (!!orderData?.application?.customer?.id && !!context?.ldClient) {
      const currentLdContext = context.ldClient.getContext();
      context.ldClient.identify(
        updateCustomerInMultiContext(currentLdContext, {
          custSorId: orderData.application.customer.id,
          applicationId: orderData?.application?.lease?.id || orderData?.application?.loan?.id,
          applicationNumber: orderData?.application?.lease?.displayId || undefined,
        }),
      );
    }

    return orderData as Order;
  } catch (err: any) {
    var error = {} as NetworkError;
    switch (err?.networkError?.statusCode) {
      case 403:
        error.forbiddenError = createForbiddenErrorMessage(err);
        break;
      case 401:
        error.unauthorizedError = createUnauthorizedErrorMessage(err);
        break;
      default:
        // TODO: handle throw createUnauthorizedErrorMessage('customer not authorized to retrieve application');
        error.errorGeneral = err;
    }
    throw error;
  }
};

export default queryOrderWithCartValidation;
